<template>
  <transition name="fade" appear>
    <l2qr-not-found v-if="hasError" />
    <l2qr-paused-qr-code v-else-if="isPaused" />
    <component v-else-if="qrCode" :is="qrCodePageComponent" />
    <div v-else />
  </transition>
</template>

<script>
import {
  pageComponents,
  pageComponentsNames,
  pagesTitles,
} from '@/constants/pages'
import { mapGetters } from 'vuex'

export default {
  name: 'L2QrPageView',
  components: {
    L2qrNotFound: () =>
      import(/* webpackChunkName: "404 not found" */ '@/components/NotFound'),
    L2qrPausedQrCode: () =>
      import(
        /* webpackChunkName: "paused qr code" */ '@/components/PausedQrCode'
      ),
    ...pageComponents,
  },
  computed: {
    ...mapGetters({
      qrCode: 'qrCode/qrCode',
      qrCodeError: 'qrCode/qrCodeError',
      qrCodeLoading: 'qrCode/qrCodeLoading',
    }),
    hasError() {
      return !this.qrCodeLoading && this.qrCodeError
    },
    isPaused() {
      return (
        !this.qrCodeLoading &&
        !this.qrCodeError &&
        this.qrCode?.status === 'paused'
      )
    },
    qrCodePageComponent() {
      return pageComponentsNames[this.qrCode.data_format] || 'div'
    },
  },
  async created() {
    await this.$store.dispatch('qrCode/getQrCode', {
      key: this.$route.params.key,
    })

    this.setDocumentTitle()
  },
  methods: {
    setDocumentTitle() {
      let title
      if (this.hasError) title = 'L2QR - Not found'
      else if (this.isPaused) title = 'L2QR - Paused Code'
      else title = pagesTitles[this.qrCode?.data_format]
      if (title) document.title = title
    },
  },
}
</script>
